import { MainMobileHeaderItem, SecondaryMobileHeaderItem, MenuSettings, ScrollMobileHeaderItem, PaywallMenuDataMutam } from "./categoryHeaderMutamWrapper"
import { categoryObj } from "../../../../ynet1280/videoGalleryVerticalWidget/components/videoGalleryVerticalMutamComponenta";
import { CategoryHeaderMutamSideMenuNewDesign } from "./categoryHeaderMutamSideMenuNewDesign";
import { useState } from "react"
import { HyperLinkBuilder, SimpleLinkRenderer } from "../../../../../commonComponents/inline/hyperLink"
import { FontSlider } from "../../../../ynet1280/ynetHeader/components/mutamComponents/fontSliderComponent";
import { WhatsAppShareButton } from "../../../../../siteWidgets/socialShareButtons/whatsApp/whatsAppShareButton";

require('./m_calcalist_categoryHeaderMutamNewDesign.less')


interface CategoryHeaderMutamProps {
    mainItems: MainMobileHeaderItem[]
    secondaryItems: SecondaryMobileHeaderItem[]
    scrollItems: ScrollMobileHeaderItem[]
    category: categoryObj 
    menuSettings: MenuSettings
    isArticlePage: boolean
    domain: string
    paywallMenuDataMutam: PaywallMenuDataMutam
    headerNewDesign?: boolean
}

export const CategoryHeaderMutamNewDesign  = (props: CategoryHeaderMutamProps) => {
    const { mainItems, secondaryItems, scrollItems, category, menuSettings, isArticlePage, domain, paywallMenuDataMutam, headerNewDesign } = props
    const [showSideMenu, setShowSideMenu] = useState<boolean>(false)
    const [isFontMenuOpen, setIsFontMenuOpen] = useState<boolean>(false)
    let selectedId = category ? category.id : "";
    const selectedCategory = mainItems.find(item => item.categoryId === selectedId) || secondaryItems.find(item => item.categoryId === selectedId)
    const overflow = showSideMenu ? "hidden" : "scroll";
    const bodyStyle = `body {overflow: ${overflow} !important;}`

    const handleFontSizePopupVisability =() =>{
        setIsFontMenuOpen(!isFontMenuOpen)         
    }

    const onSideMenuBtnClick = () => {
        setShowSideMenu(!showSideMenu)
    }
    const openShare = async () => {
        const current_url = `${window.location.href}?utm_source=${domain}&utm_medium=social&utm_campaign=general_share`;
        const shareData = { url: current_url }
        try {
            await navigator.share(shareData)
        } catch (err) {
            console.log("error with sharing function", err);
        }
    }

    const handleShareBtnClicked = () => {
        if (typeof window !== "undefined") {
            const current_url = window.location.href;
            WhatsAppShareButton.openWhatsAppShare(current_url, undefined, "")   
        }
    }
    

    return (
      <>
      <div className="category-header-mutam-newDesign" style={{ backgroundColor: selectedCategory && selectedCategory.bgColor ? selectedCategory.bgColor : "#d01e25" }}>
            <style>
                {bodyStyle}
            </style>
    
            <CategoryHeaderMutamSideMenuNewDesign
                domain={domain}
                mainItems={mainItems}
                showSideMenu={showSideMenu}
                menuSettings={menuSettings}
                secondaryItems={secondaryItems}
                oncloseMenu={onSideMenuBtnClick}
                paywallMenuDataMutam={paywallMenuDataMutam}
            />

            <div className="header-left">
                {isArticlePage ? (
                <>
                        <a className="share-btn" onClick={openShare}></a>
                        <a className="whatsapp-btn" onClick={handleShareBtnClicked}></a>
                </>
                   ) : (
                    <>
                    {paywallMenuDataMutam.showPaywallMenu && 
                        <HyperLinkBuilder href={paywallMenuDataMutam.subscribeBtnLink.link} linkTarget={paywallMenuDataMutam.subscribeBtnLink.linkTarget} className="digitalEdition">
                            המהדורה הדיגיטלית
                        </HyperLinkBuilder>
                    }
                    
                    <SimpleLinkRenderer href="http://calcalist.co.il/allnews" className="hours-btn" title="24.7">
                    <span>{"24/7"}</span>
                    </SimpleLinkRenderer>
                </>
                )}
            </div>
         
        <SimpleLinkRenderer href="https://calcalist.co.il" className="heder-title" title="calcalist">
        </SimpleLinkRenderer>

       <div className="header-right">
        {isArticlePage && <a className="accessibility-btn resize_font" onClick={handleFontSizePopupVisability}></a>}
        {isFontMenuOpen && <div className="FontContainer"><FontSlider lang="he" onClose={() => setIsFontMenuOpen(false)} /></div>}      
        <div className="menu-btn icon" onClick={onSideMenuBtnClick}></div>
       </div>

      </div>
     
            {isArticlePage || (selectedCategory && selectedCategory.categoryId !== "8" && selectedCategory.title) &&
             <div className="title_category">
              <div className="title_category_text">
              {isArticlePage ? 
                category.name 
              : selectedCategory.title
              }
              </div>
            </div>
          }
      </>
    );
  };

CategoryHeaderMutamNewDesign.siteScriptName = "CategoryHeaderMutamNewDesign";
